/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * QoE time buckets tracked by the playback session accumulator.
 * Every millisecond of a session is assigned to exactly one bucket.
 */
export enum PlaybackSessionBucket {
  NONE = "NONE",
  BUFFERING = "BUFFERING",
  STALLING = "STALLING",
  PLAYING = "PLAYING",
  PAUSED = "PAUSED",
  TRICK_PLAY = "TRICK_PLAY"
}
